@if(imageDisplay === 'link') {
  <div id="photo-camera">
    
    @if(imageName !== null) {
      <div class="photo-camera-distribution">
        
        @if (imageModel.imagen || imageModel.image_after) {
          <i class="fa fa-picture-o icon-picture" aria-hidden="true" (click)="viewImage()"></i>
        }
        
        @if (formType < 3) {
          <app-reactive-camera (sendCameraFile)="uploadFile($event)"></app-reactive-camera>
        }

      </div>
    }

  </div>
} @else {
  <div class="col-sm-2 mb-5">
    <input type="file" #adjuntarFoto (change)="uploadFile($event)" style="display: none;" accept="image/*" />
    
    <div class="d-flex justify-content-center">
      <input
        type="button"
        class="btn"
        style='border-radius: 5px;
              font-size: 1em;
              padding: 6px 12px;
              font-family: "Roboto", "Trebuchet MS", Arial, Helvetica, sans-serif;
              background-color: #27A745;
              color: white;'
        value="Añadir foto"
        (click)="adjuntarFoto.click()" />
    </div>
    
    <img 
      [src]="serverUrl + imageFolder + '/' + imageModel[imageName ?? '']" 
      *ngIf="imageModel[imageName ?? '']" 
      width="100%"
      height="100%" 
      alt="Foto Producto">
</div>
}
